import { render, staticRenderFns } from "./UpdateVersion.vue?vue&type=template&id=cc89bdba&scoped=true"
import script from "./UpdateVersion.vue?vue&type=script&lang=js"
export * from "./UpdateVersion.vue?vue&type=script&lang=js"
import style0 from "./UpdateVersion.vue?vue&type=style&index=0&id=cc89bdba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc89bdba",
  null
  
)

export default component.exports